module.exports = __webpack_public_path__ + "media/loading@2x.394bc801.mp4";